export const EXTENSION_PDF = 'pdf';
export const EXTENSION_JPG = 'jpg';
export const EXTENSION_PNG = 'png';
export const EXTENSION_LDT = 'ldt';
export const EXTENSION_DXF = 'dxf';
export const EXTENSION_IES = 'ies';
